// The brand is always written CONFORM.TOOLS in user-facing text, matching the
// wordmark artwork used in the header, footer and OG images.
//
// Lowercase survives ONLY in machine addresses, where the casing belongs to the
// address rather than the brand: URLs (https://conform.tools, the Instagram
// profile, schema.org @id values), email addresses (support@conform.tools), and
// the desktop-app user-agent probe in config/features.js, which matches against
// a lowercased navigator.userAgent and would break if capitalized.
//
// JSX prose keeps the literal "CONFORM.TOOLS" instead of interpolating BRAND:
// `built by {BRAND} today` renders as adjacent text nodes, which react-snap
// serializes into a single node and React then cannot hydrate. See the
// hydration invariants in docs/SEO_DEPLOYMENT.md.
export const BRAND = 'CONFORM.TOOLS';

/** Full product name: the brand plus the app. */
export const BRAND_APP = `${BRAND} DataCalc`;
